import React from "react";
import { Link } from "react-router-dom";
import { Section, Overline, H1 } from "@/components/ui-kit";

export default function NotFound() {
  return (
    <Section className="pt-32 pb-32 text-center">
      <Overline>404</Overline>
      <H1 className="mt-4">Page not found.</H1>
      <p className="text-neutral-400 mt-6">The page you're looking for doesn't exist or has moved.</p>
      <Link to="/" className="btn-gold inline-block mt-10 px-7 py-3.5 font-semibold">Back to Home</Link>
    </Section>
  );
}
